import React, { useState } from "react";
import "../Hamburger/Hamburger.scss";

export default function Hamburger(props) {
	const [isOpen, changeState] = useState(false);

	function openMenu() {
		const next = !isOpen;
		changeState(next);
		props.openMenu(next);
	}

	return (
		<button
			className={"hamburger" + (isOpen ? " hamburger--close" : "")}
			onClick={openMenu}
			aria-label={isOpen ? "Закрити меню" : "Відкрити меню"}
			aria-expanded={isOpen}
			aria-controls="mobile-menu"
			type="button"
		>
			<div className="hamburger__dash" />
			<div className="hamburger__dash" />
			<div className="hamburger__dash" />
		</button>
	);
}
